// extracted by mini-css-extract-plugin
export default {"container":"CallCenterComplianceIssues_container__QcY36"};